import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-i-invested-standard-list-panel" }
const _hoisted_2 = { class: "p-i-invested-standard-list-panel__heaer" }
const _hoisted_3 = { class: "p-i-invested-standard-list-panel__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallText = _resolveComponent("SmallText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SmallText, {
        size: _ctx.textSize(16)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "heading", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["size"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, [
        _createVNode(_component_SmallText, {
          size: _ctx.textSize(18),
          weight: "bold",
          color: "#616161"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "content", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["size"])
      ])
    ])
  ]))
}